import { STATES } from '../../constants/states';
import { TITLE } from '../new-product-intro/new-product-intro.constants';

export const NEXT_STEP_URL = '/next-task';

export function NextStepConfig($stateProvider) {
  'ngInject';

  $stateProvider.state(STATES.NEXT_STEP, {
    url: NEXT_STEP_URL,
    disableBreadcrumb: true,
    views: {
      '@': {
        template: `<upd-new-product-intro 
          use-alternate-weight="{{useAlternateWeight}}"
          title="title"
          subtitle="subtitle"
        >
        </upd-new-product-intro>`,
        controller: ($stateParams, $scope) => {
          $scope.useAlternateWeight = !$stateParams.showDefaultWeights;
          $scope.title = $stateParams.overrideTitle || TITLE;
          $scope.subtitle = $stateParams.subtitle;
        },
      },
    },
    scrollTop: true,
    analytics: {
      page: 'Next Step',
    },
    data: {
      permissions: 'signedIn',
    },
    params: {
      showDefaultWeights: false,
      overrideTitle: false,
      subtitle: false,
    },
  });
}
